"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriftCard = void 0;
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const Stack_1 = require("../stack/Stack");
const Paper_1 = require("../paper/Paper");
const Box_1 = require("../box/Box");
const DriftCardContainer = (0, material_1.styled)(Paper_1.Paper, {
    name: 'DriftCard',
    slot: 'root',
})(({ ownerState }) => ({
    borderRadius: ownerState.square ? '0' : '4px',
    cursor: ownerState.onClick ? 'pointer' : 'default',
}));
const RightAdornment = (0, material_1.styled)(Box_1.Box, {
    name: 'DriftCard',
    slot: 'rightAdornment',
})(({ theme }) => ({}));
const Title = (0, material_1.styled)(Stack_1.Stack, {
    name: 'DriftCard',
    slot: 'title',
})(({ theme }) => ({}));
exports.DriftCard = react_1.default.forwardRef((inProps, ref) => {
    const props = (0, material_1.useThemeProps)({ props: inProps, name: 'DriftCard' });
    const { title, children, rightAdornment, onClick, variant, elevation, square, sx, classes, titleSx, forceHoverState, } = props;
    return (react_1.default.createElement(DriftCardContainer, { ref: ref, classes: Object.assign({}, classes), variant: variant || 'outlined', sx: Object.assign(Object.assign({}, sx), { backgroundColor: forceHoverState ? '#F9F9F9' : null }), elevation: elevation || 0, square: square || false, onClick: () => {
            if (onClick)
                onClick();
        }, ownerState: Object.assign(Object.assign({}, props), { square, onclick }) },
        react_1.default.createElement(Box_1.Box, null,
            react_1.default.createElement(Title, { direction: "row", spacing: 1, ref: ref, sx: titleSx }, title),
            children),
        rightAdornment && react_1.default.createElement(RightAdornment, { ref: ref }, rightAdornment)));
});
//# sourceMappingURL=DriftCard.js.map